import React from 'react'
import BentoTile from './BentoTile'
import { sectionTeaserCopy } from './copy'
import EmptyState from './EmptyState'

interface SectionTeaserProps {
	/** Pre-sized section icon for the header chip. */
	icon: React.ReactNode
	label: string
	/**
	 * How the lock line names the section ("…to view {noun}"). Defaults to the
	 * lowercased label; pass it when the label isn't the natural noun (e.g.
	 * "the itinerary").
	 */
	noun?: string
	/** Real count — a teaser advertises how much is hidden (teaser ≠ empty, ADR 0003). */
	count?: React.ReactNode
	colSpan: number
	rowSpan?: number
	loading?: boolean
}

/**
 * The public-mode teaser tile shared by the non-money sections: header + count
 * survive, the body is the lock line, and there is no footer or click-through —
 * no section content may leak into the markup. (The money tile has its own
 * teaser: the anonymous spend summary.)
 */
const SectionTeaser: React.FC<SectionTeaserProps> = ({ icon, label, noun, count, colSpan, rowSpan, loading }) => (
	<BentoTile
		icon={icon}
		label={label}
		count={count}
		ariaLabel={`${label} hidden on this shared link`}
		colSpan={colSpan}
		rowSpan={rowSpan}
		loading={loading}
	>
		<EmptyState text={sectionTeaserCopy(noun ?? label.toLowerCase())} />
	</BentoTile>
)

export default SectionTeaser
